import React from 'react';
import { Carousel } from 'antd';

import './LeftBanner.scss';
import useContent from '../../../../core/hooks/useContent';
import useAuthBrand from '../../../../core/hooks/useAuthBrand';

// Tailwind sınıfları burada durmalı: tailwind.config.js yalnızca src/pages ve
// src/components altını tarar, src/core altındaki string'ler üretilmez.
const imageClassNames: Record<'landscape' | 'portrait', string> = {
  landscape: 'w-11/12 max-w-lg',
  portrait: 'w-auto max-w-[16rem] max-h-[60vh] object-contain',
};

const LeftBanner: React.FC = () => {
  const content = useContent();
  const { bannerBg, bannerImageFit, slides } = useAuthBrand();

  // --banner-bg global olarak index.tsx'te set ediliyor; markaya özel arka planı
  // element üzerinde ezerek scss'e dokunmadan override ediyoruz.
  const bannerStyle = {
    '--banner-bg': `url(${bannerBg})`,
  } as React.CSSProperties;

  return (
    <div
      id="left-banner"
      className="flex flex-col rounded-r-2xl items-center justify-center w-2/5 max-lg:hidden"
      style={bannerStyle}
    >
      <Carousel className="app-carousel" autoplay>
        {slides.map((slide) => (
          <div key={slide.textKey}>
            <h3 className="flex flex-col items-center justify-center space-y-6">
              <img
                src={slide.image}
                className={imageClassNames[bannerImageFit]}
                alt=""
              />
            </h3>
            <p className="text-base text-white font-bold text-center">
              {content(slide.textKey)}
            </p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default LeftBanner;
